import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {URLS} from '../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  notificationsUpdate: EventEmitter<any[]> = new EventEmitter();

  constructor(private http: HttpClient) {
  }

  getAccount() {
    return this.http.get(URLS.API + 'account', {withCredentials: true}).pipe(map((res: any) => {
      return res.data;
    }));
  }

  getNotifications() {
    return this.http.get(URLS.API + 'account/notifications', {withCredentials: true}).pipe(map((res: any) => {
      return res.data;
    }));
  }

  getNotificationsSimple() {
    return this.http.get(URLS.API + 'account/notifications/simple', {withCredentials: true}).pipe(map((res: any) => {
      return res.data;
    }));
  }

  updateNotification(notification: any) {
    return this.http.post(URLS.API + 'account/notifications/update', {notification}, {withCredentials: true}).pipe(map((res: any) => {
      return res.data;
    }));
  }
}
